<template>
  <v-dialog v-model="showDetails" max-width="500" persistent>
    <v-card>
      <v-card-title class="primary white--text title"
        >5G Order Details</v-card-title
      >

      <v-card-text class="subtitle-1 pb-0 pt-4">
        <div style="overflow-x: auto">
          <div class="details-wrapper">
            <div class="name text-right py-1">Account Number:</div>
            <div class="value py-1 ml-2">{{ orderData.accountNumber }}</div>

            <div class="name text-right py-1">Customer Name:</div>
            <div class="value py-1 ml-2">{{ orderData.customerName }}</div>

            <div class="name text-right py-1">Address:</div>
            <div class="value py-1 ml-2">{{ orderData.address }}</div>

            <div class="name text-right py-1">MSN:</div>
            <div class="value py-1 ml-2">{{ orderData.msn }}</div>

            <div class="name text-right py-1">SIM:</div>
            <div class="value py-1 ml-2">{{ orderData.sim }}</div>

            <div class="name text-right py-1">Status Reply:</div>
            <div class="value py-1 ml-2">{{ orderData.statusReply }}</div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="pt-0 pb-3 px-3">
        <v-spacer></v-spacer>
        <v-btn text class="primary" @click="close()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "OrderDetails",
  props: {
    showDetails: { type: Boolean },
    orderData: { type: Object },
  },
  methods: {
    close() {
      this.$emit("closePrompt");
    },
  },
};
</script>

<style lang="scss" scoped>
.name {
  width: 120px;
  display: inline-block;
  font-weight: bold;
}

.value {
  width: 335px;
  display: inline-block;
}

@media screen and (max-width: 1100px) {
  .details-wrapper {
    width: 600px;
  }
}
</style>
